<template>
  <div class="col-md mstabsdetails__content">
    <div class="mstabsdetails__content--title mb-3">SHIPPER DETAILS</div>
    <div class="row m-0 mstabsdetails__content--info"
    v-for="(item, i) in data" :key="i" :class="canEdit ? 'mb-2' : 'mb-1'">
      <div class="col-md-3 p-0">{{item.label}}</div>
      <div class="col-md-0 px-1">:</div>
      <div class="col-md p-0 blue" v-if="!canEdit">{{item.value || '-'}}</div>
      <div class="col-md-5 p-0" v-else>
        <input class="input_field" v-validate="{required : item.required}"
        :name="item.label" :type="item.type" v-model="item.value">
        <p v-if="errors.has(item.label)" class="global__texterror text-left pt-0 pb-2">
          {{ errors.first(item.label) }}
        </p>
      </div>
    </div>
    <button :class="`${detail.freightMode === 'OCEAN' ? 'button__bluecorporite' : detail.freightMode === 'AIR' ? 'button__purplecorporite' : detail.freightMode === 'LAND' ? 'button__deepgreen' : '' } mt-3`" v-if="isUpdating">
      <b-spinner small variant="secondary"></b-spinner>
    </button>
    <button :class="`${detail.freightMode === 'OCEAN' ? 'button__bluecorporite' : detail.freightMode === 'AIR' ? 'button__purplecorporite' : detail.freightMode === 'LAND' ? 'button__deepgreen' : '' } mt-3`"
    v-else-if="!canEdit && !isUpdating" @click="chooseEdit(true)">Edit</button>
    <div class="row m-0 mt-3" v-else-if="canEdit && !isUpdating">
      <button class="button__redsmall mr-3" @click="updateData">Save</button>
      <button class="button__whitesmall" @click="chooseEdit(false)">Cancel</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import mixinDate from '@/mixin/getters/date-time'
import mixinShipmentDetails from '@/mixin/getters/shipment-details'
import mixinFunctions from '@/mixin/getters/functions'

export default {
  name: 'ShipperDetails',
  mixins: [mixinDate, mixinShipmentDetails, mixinFunctions],
  props: {
    canEdit: Boolean
  },
  data: () => ({
    form: {},
    shipmentId: '',
    orderNumber: '',
    data: [
      {
        label: 'Company Name',
        payloadVar: 'shipperCompany',
        type: 'text',
        required: true,
        value: ''
      },
      {
        label: 'PIC Name',
        payloadVar: 'shipperPICName',
        type: 'text',
        required: true,
        value: ''
      },
      {
        label: 'Address',
        payloadVar: 'shipperAddress',
        type: 'text',
        required: true,
        value: ''
      },
      {
        label: 'Phone',
        payloadVar: 'shipperPhone',
        type: 'number',
        required: true,
        value: ''
      },
      {
        label: 'ZIP Code',
        payloadVar: 'shipperZipCode',
        type: 'number',
        required: true,
        value: ''
      },
      {
        label: 'Company Tax ID',
        payloadVar: 'shipperCompanyTaxId',
        type: 'text',
        required: false,
        value: ''
      },
      {
        label: 'Notes',
        payloadVar: 'shipperNotes',
        type: 'text',
        required: false,
        value: ''
      },
      {
        label: 'PO Number (Optional)',
        payloadVar: 'poNumber',
        type: 'text',
        required: false,
        value: ''
      }
    ]
  }),
  mounted () {
    this.init()
  },
  computed: {
    ...mapGetters({
      detail: 'shipment/item',
      isLoading: 'shipment/isLoading',
      isError: 'shipment/error',
      // update detail
      updated: 'shipment/isUpdated',
      isUpdating: 'shipment/isUpdating' // loading
    })
  },
  methods: {
    chooseEdit (data) {
      this.$emit('chooseEdit', data)
      this.init()
    },
    updateData () {
      this.form = {}
      this.data.forEach((item) => {
        // eslint-disable-next-line no-new-object
        var data = new Object()
        data[item.payloadVar] = item.value
        this.form = Object.assign(this.form, data, { shipperFax: null }, { consigneeFax: null })
      })
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          await this.$store.dispatch('shipment/UPDATE_SHIPMENT_DETAILS', {
            payload: this.form,
            shipmentId: this.shipmentId,
            orderNumber: this.orderNumber,
            type: 'shipperconsignee'
          })
          this.$emit('chooseEdit', false)
          this.$store.dispatch('shipment/FETCH_SHIPMENT_DETAIL', { shipmentId: this.shipmentId, orderNumber: this.orderNumber })
        }
      })
    },
    init () {
      this.shipmentId = this.detail.shipmentId
      this.orderNumber = this.detail.orderNumber.split('/').join('-')
      this.data[0].value = this.detail.shipperCompany
      this.data[1].value = this.detail.shipperName
      this.data[2].value = this.detail.shipperAddress
      this.data[3].value = this.detail.shipperPhone
      this.data[4].value = this.detail.shipperZipCode
      this.data[5].value = this.detail.shipperCompanyTaxId
      this.data[6].value = this.detail.shipperNotes
      this.data[7].value = this.mixinConvertSymbol(this.detail.poNumber, '&')
    },
    resetData () {
      this.init()
    }
  },
  created () {
    this.$eventHub.$on('reset-data', this.resetData)
  },
  beforeDestroy () {
    this.$eventHub.$off('reset-data')
  },
  watch: {
    updated (data) {
      if (data) {
        this.$emit('chooseEdit', false)
        this.$store.dispatch('shipment/FETCH_SHIPMENT_DETAIL', { shipmentId: this.shipmentId, orderNumber: this.orderNumber })
      }
    },
    detail (data) {
      if (data) {
        this.init()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/managementShipment/detail/tab-detail/ShipperDetails.vue